import { useState, useCallback } from 'react';
import axios from 'axios';

export const useApi = () => {
  const [response, setResponse] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const search = useCallback(async (query) => {
    setResponse(null);
    setIsError(false);
    setLoading(true);

    try {
      const result = await axios(query);
      setResponse(result.data);
    } catch (error) {
      setIsError(true);
    }
    setLoading(false);
  }, []);

  return { response, isLoading, isError, search };
};
